import React, { useEffect, useState, useCallback, useRef, useMemo } from 'react';
import AntAPI from '../../utils/AntAPI';
import AntLocalization from '../../utils/AntLocalization';
import AntTime from '../../utils/AntTime';
import './AIWizardPanel.scss';

var aivaAPI = null;
function getAPI() {
    if (!aivaAPI) aivaAPI = new AntAPI('ai', 'AIVoucherAnalysis');
    return aivaAPI;
}
var aivadAPI = null;
function getDocAPI() {
    if (!aivadAPI) aivadAPI = new AntAPI('ai', 'AIVoucherAnalysisDoc');
    return aivadAPI;
}

var MODE_LABEL = {
    Quick: { vi: 'Nhanh', en: 'Quick', fr: 'Rapide', es: 'Rápido', id: 'Cepat', ja: '高速', zh: '快速', ko: '빠름', hi: 'त्वरित', ar: 'سريع' },
    Standard: { vi: 'Tiêu chuẩn', en: 'Standard', fr: 'Standard', es: 'Estándar', id: 'Standar', ja: '標準', zh: '标准', ko: '표준', hi: 'मानक', ar: 'قياسي' },
    Deep: { vi: 'Chuyên sâu', en: 'Deep', fr: 'Approfondi', es: 'Profundo', id: 'Mendalam', ja: '詳細', zh: '深度', ko: '심층', hi: 'गहन', ar: 'متعمق' }
};
var VALIDATION_LABEL = {
    Valid: { vi: 'Hợp lệ', en: 'Valid', fr: 'Valide', es: 'Válido', id: 'Valid', ja: '有効', zh: '有效', ko: '유효', hi: 'मान्य', ar: 'صالح' },
    HasIssues: { vi: 'Có cảnh báo', en: 'Has issues', fr: 'Avec alertes', es: 'Con alertas', id: 'Ada peringatan', ja: '警告あり', zh: '有警告', ko: '경고 있음', hi: 'चेतावनी है', ar: 'به تحذيرات' },
    Invalid: { vi: 'Không hợp lệ', en: 'Invalid', fr: 'Non valide', es: 'No válido', id: 'Tidak valid', ja: '無効', zh: '无效', ko: '무효', hi: 'अमान्य', ar: 'غير صالح' },
    Pending: { vi: 'Chờ kiểm tra', en: 'Pending', fr: 'À vérifier', es: 'Por revisar', id: 'Menunggu cek', ja: '確認待ち', zh: '待检查', ko: '확인 대기', hi: 'जाँच लंबित', ar: 'بانتظار الفحص' }
};

function statusBadge(row) {
    var a = String(row.analysis_status || '').toLowerCase();
    if (a === 'running') return { key: 'running', text: AntLocalization.translateText({ vi: 'Đang phân tích', en: 'Analyzing', fr: 'Analyse en cours', es: 'Analizando', id: 'Menganalisis', ja: '分析中', zh: '分析中', ko: '분석 중', hi: 'विश्लेषण जारी', ar: 'جارٍ التحليل' }) };
    if (a === 'failed') return { key: 'failed', text: AntLocalization.translateText({ vi: 'Lỗi', en: 'Failed', fr: 'Échec', es: 'Error', id: 'Gagal', ja: '失敗', zh: '失败', ko: '실패', hi: 'विफल', ar: 'فشل' }) };
    var ap = String(row.apply_status || '').toLowerCase();
    if (ap === 'applied') return { key: 'applied', text: AntLocalization.translateText({ vi: 'Đã áp dụng', en: 'Applied', fr: 'Appliqué', es: 'Aplicado', id: 'Diterapkan', ja: '適用済み', zh: '已应用', ko: '적용됨', hi: 'लागू', ar: 'تم التطبيق' }) };
    if (ap === 'discarded') return { key: 'discarded', text: AntLocalization.translateText({ vi: 'Đã bỏ', en: 'Discarded', fr: 'Écarté', es: 'Descartado', id: 'Dibuang', ja: '破棄済み', zh: '已放弃', ko: '폐기됨', hi: 'त्यागा गया', ar: 'مُستبعد' }) };
    if (ap === 'pending') return { key: 'pending', text: AntLocalization.translateText({ vi: 'Chờ duyệt', en: 'Pending', fr: 'En attente', es: 'Pendiente', id: 'Menunggu', ja: '承認待ち', zh: '待审批', ko: '대기', hi: 'लंबित', ar: 'قيد الانتظار' }) };
    return { key: 'done', text: AntLocalization.translateText({ vi: 'Hoàn tất', en: 'Done', fr: 'Terminé', es: 'Hecho', id: 'Selesai', ja: '完了', zh: '完成', ko: '완료', hi: 'संपन्न', ar: 'تم' }) };
}

function isImageMime(mime, name) {
    var m = String(mime || '').toLowerCase();
    var n = String(name || '').toLowerCase();
    return m.indexOf('image') === 0 || /\.(jpe?g|png|gif|webp|bmp|svg)$/.test(n);
}

function fmtSize(bytes) {
    var n = Number(bytes);
    if (!isFinite(n) || n <= 0) return '';
    if (n < 1024) return n + ' B';
    if (n < 1024 * 1024) return (n / 1024).toFixed(1) + ' KB';
    return (n / 1024 / 1024).toFixed(2) + ' MB';
}

function fmtTime(unix) {
    if (!unix) return '';
    try {
        return AntTime.fromUnix(unix).format('DD/MM/YYYY HH:mm');
    } catch (e) {
        return '';
    }
}

function IconDoc() {
    return (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
        </svg>
    );
}
function IconImage() {
    return (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <circle cx="9" cy="9" r="2" />
            <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
        </svg>
    );
}
function IconTrash() {
    return (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="3 6 5 6 21 6" />
            <path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6" />
            <path d="M10 11v6M14 11v6" />
            <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
        </svg>
    );
}

export default function AIWizardPanel(props) {
    var context = props.context || {};
    var data = context.data || {};
    var session = context.session || null;
    var aiExtract = data.aiExtract;
    var targetTable = aiExtract && aiExtract.target_table;
    var targetId = aiExtract && aiExtract.target_id;
    var canAnalyze = !!(aiExtract && aiExtract.canAnalyze !== false);

    var [rows, setRows] = useState([]);
    var [docsMap, setDocsMap] = useState({});
    var [loading, setLoading] = useState(false);
    var [error, setError] = useState(null);
    var mountedRef = useRef(true);
    var rowsRef = useRef([]);
    var pollTimerRef = useRef(null);

    var fetchDocs = useCallback(function (codes) {
        if (!codes || !codes.length) return;
        var api = getDocAPI();
        codes.forEach(function (code) {
            api.post('/' + api.routeURL + '/listForAnalysis', { analysis_code: code }, function (resp) {
                if (!mountedRef.current) return;
                var d = (resp && resp.data) || resp || {};
                var list = (d && d.rows) || (Array.isArray(d) ? d : []) || [];
                setDocsMap(function (prev) {
                    var next = Object.assign({}, prev);
                    next[code] = list;
                    return next;
                });
            });
        });
    }, []);

    var load = useCallback(
        function () {
            if (!targetTable || !targetId) return;
            setLoading(true);
            var api = getAPI();
            api.post(
                '/' + api.routeURL + '/list',
                {
                    target_table: targetTable,
                    target_id: targetId,
                    ordering: [{ field: 'id', dir: 'desc' }],
                    pageSize: 50
                },
                function (resp) {
                    if (!mountedRef.current) return;
                    setLoading(false);
                    var d = (resp && resp.data) || resp || {};
                    if (d.error) {
                        setError(d.message || 'Load failed');
                        return;
                    }
                    setError(null);
                    var list = d.rows || [];
                    rowsRef.current = list;
                    setRows(list);
                    fetchDocs(list.map(function (r) { return r.code; }).filter(Boolean));
                }
            );
        },
        [targetTable, targetId, fetchDocs]
    );

    useEffect(
        function () {
            mountedRef.current = true;
            load();
            return function () {
                mountedRef.current = false;
            };
        },
        [load]
    );

    // ─── Socket subscription ────────────────────────────────────
    useEffect(
        function () {
            if (!session || !session.registerSocketListener) return;
            if (!targetTable || !targetId) return;
            var key = 'AIWizardPanel-' + targetTable + '-' + targetId;
            var onSocketReceived = function (msg) {
                if (!msg || !msg.event) return false;
                if (String(msg.event).indexOf('AIVoucherAnalysis-') !== 0) return false;
                var p = msg.data || {};
                if (p.target_table !== targetTable) return false;
                if (String(p.target_id) !== String(targetId)) return false;
                load();
                return true;
            };
            session.registerSocketListener(onSocketReceived, key);
            return function () {
                session.clearSocketListener(key);
            };
        },
        [session, targetTable, targetId, load]
    );

    // ─── Polling timer while any row is Running ─────────────────
    useEffect(
        function () {
            var anyRunning = rows.some(function (r) {
                return String(r.analysis_status || '').toLowerCase() === 'running';
            });
            if (!anyRunning) {
                if (pollTimerRef.current) {
                    clearInterval(pollTimerRef.current);
                    pollTimerRef.current = null;
                }
                return;
            }
            if (pollTimerRef.current) return;
            pollTimerRef.current = setInterval(function () {
                if (mountedRef.current) load();
            }, 3000);
            return function () {
                if (pollTimerRef.current) {
                    clearInterval(pollTimerRef.current);
                    pollTimerRef.current = null;
                }
            };
        },
        [rows, load]
    );

    var startNew = useCallback(
        function () {
            var actions = context.voucherActions;
            if (actions && actions.showAIAnalyzer) {
                actions.showAIAnalyzer({ mode: 'new' });
            }
        },
        [context]
    );

    var reviewRow = useCallback(
        function (row) {
            var actions = context.voucherActions;
            if (actions && actions.showAIReview) {
                actions.showAIReview(row);
                return;
            }
            if (actions && actions.showAIAnalyzer) {
                actions.showAIAnalyzer({ mode: 'review', analysisCode: row.code });
            }
        },
        [context]
    );

    // ─── Drag-drop: accept application/x-meddoc → AIVoucherAnalysis.actionAnalyzeForVoucher ──
    var voucherStatus = (data && (data.status || data.state)) || null;
    var canDropMedDoc = useMemo(
        function () {
            if (!targetTable || !targetId) return false;
            // Voucher editable: status in ['New','Pending'] hoặc undefined (chưa load)
            if (voucherStatus && ['New', 'Pending'].indexOf(voucherStatus) < 0) return false;
            return true;
        },
        [targetTable, targetId, voucherStatus]
    );

    var handleAiWizardDragOver = useCallback(
        function (e) {
            if (!canDropMedDoc) return;
            if (
                e.dataTransfer &&
                e.dataTransfer.types &&
                Array.prototype.indexOf.call(e.dataTransfer.types, 'application/x-meddoc') >= 0
            ) {
                e.preventDefault();
                e.dataTransfer.dropEffect = 'copy';
            }
        },
        [canDropMedDoc]
    );

    var handleAiWizardDrop = useCallback(
        function (e) {
            if (!canDropMedDoc) return;
            if (
                !e.dataTransfer ||
                !e.dataTransfer.types ||
                Array.prototype.indexOf.call(e.dataTransfer.types, 'application/x-meddoc') < 0
            )
                return;
            e.preventDefault();
            e.stopPropagation();
            try {
                var payload = JSON.parse(e.dataTransfer.getData('application/x-meddoc'));
                var api = getAPI();
                api.post(
                    '/' + api.routeURL + '/actionAnalyzeForVoucher',
                    {
                        target_table: targetTable,
                        target_code: aiExtract && aiExtract.target_code,
                        target_id: targetId,
                        med_doc_code: payload.document_code,
                        med_doc_id: payload.document_id,
                        intent: 'UpdateExisting',
                        source_channel: 'Toolbar',
                        run_mode: 'async',
                        auto_apply: true,
                        auto_release: false
                    },
                    function () {
                        if (mountedRef.current) load();
                    }
                );
            } catch (err) {
                console.error('[AIWizardPanel drop x-meddoc] error:', err && err.message);
            }
        },
        [canDropMedDoc, targetTable, targetId, aiExtract, load]
    );

    var deleteRow = useCallback(
        function (row) {
            if (!row || !row.id) return;
            var confirmMsg = AntLocalization.translateText({
                vi: 'Xoá phân tích này? Tất cả tài liệu đính kèm trong kho cũng sẽ bị xoá vĩnh viễn.',
                en: 'Delete this analysis? All attached documents in storage will also be permanently removed.',
                fr: 'Supprimer cette analyse ? Tous les documents joints stockés seront aussi supprimés définitivement.',
                es: '¿Eliminar este análisis? Los documentos adjuntos almacenados también se eliminarán permanentemente.',
                id: 'Hapus analisis ini? Semua dokumen terlampir di penyimpanan juga akan dihapus permanen.',
                ja: 'この分析を削除しますか？保存された添付書類もすべて完全に削除されます。',
                zh: '删除此分析？存储中的所有附件文档也将被永久删除。',
                ko: '이 분석을 삭제할까요? 저장소의 모든 첨부 문서도 영구 삭제됩니다.',
                hi: 'यह विश्लेषण हटाएँ? संग्रह में संलग्न सभी दस्तावेज़ भी स्थायी रूप से हट जाएँगे।',
                ar: 'حذف هذا التحليل؟ ستُحذف نهائيًا جميع المستندات المرفقة في المخزن أيضًا.'
            });
            if (typeof window !== 'undefined' && window.confirm && !window.confirm(confirmMsg)) return;
            var api = getAPI();
            api.post(
                '/' + api.routeURL + '/delete',
                { id: row.id },
                function (resp) {
                    if (!mountedRef.current) return;
                    var d = (resp && resp.data) || resp || {};
                    if (d.error) {
                        setError(d.message || (typeof d.error === 'string' ? d.error : 'Delete failed'));
                        return;
                    }
                    setError(null);
                    load();
                }
            );
        },
        [load]
    );

    if (!aiExtract || !aiExtract.enabled) {
        return (
            <div className="ant-aiwizard-panel">
                <div className="ant-aiwizard-empty">
                    {AntLocalization.translateText({
                        vi: 'Phiếu này chưa bật AI extract',
                        en: 'AI extract is not enabled for this voucher',
                        fr: 'L\'extraction IA n\'est pas activée pour ce document',
                        es: 'Extracción IA no activada para este documento',
                        id: 'Ekstraksi AI belum aktif untuk dokumen ini',
                        ja: 'この伝票ではAI抽出が有効になっていません',
                        zh: '此单据未启用 AI 提取',
                        ko: '이 전표는 AI 추출이 활성화되지 않았습니다',
                        hi: 'इस दस्तावेज़ के लिए AI एक्सट्रैक्ट चालू नहीं है',
                        ar: 'استخراج AI غير مفعّل لهذا المستند'
                    })}
                </div>
            </div>
        );
    }

    var lblOk = AntLocalization.translateText({ vi: 'hợp lệ', en: 'ok', fr: 'valides', es: 'válidos', id: 'valid', ja: '有効', zh: '有效', ko: '유효', hi: 'मान्य', ar: 'صالح' });
    var lblErr = AntLocalization.translateText({ vi: 'lỗi', en: 'err', fr: 'err.', es: 'err.', id: 'gagal', ja: 'エラー', zh: '错误', ko: '오류', hi: 'त्रुटि', ar: 'خطأ' });
    var lblSkip = AntLocalization.translateText({ vi: 'bỏ qua', en: 'skip', fr: 'ignorés', es: 'omitidos', id: 'dilewati', ja: 'スキップ', zh: '跳过', ko: '건너뜀', hi: 'छोड़े', ar: 'متخطى' });

    return (
        <div className="ant-aiwizard-panel" onDragOver={handleAiWizardDragOver} onDrop={handleAiWizardDrop}>
            {canAnalyze && (
                <button className="ant-aiwizard-new" onClick={startNew}>
                    + {AntLocalization.translateText({ vi: 'Phân tích mới', en: 'New Analysis', fr: 'Nouvelle analyse', es: 'Nuevo análisis', id: 'Analisis baru', ja: '新規分析', zh: '新建分析', ko: '새 분석', hi: 'नया विश्लेषण', ar: 'تحليل جديد' })}
                </button>
            )}
            {error && <div className="ant-aiwizard-error">{error}</div>}
            <div className="ant-aiwizard-list">
                {loading && rows.length === 0 && (
                    <div className="ant-aiwizard-empty">
                        {AntLocalization.translateText({ vi: 'Đang tải...', en: 'Loading...', fr: 'Chargement...', es: 'Cargando...', id: 'Memuat...', ja: '読み込み中...', zh: '加载中...', ko: '로딩 중...', hi: 'लोड जारी...', ar: 'يتم التحميل...' })}
                    </div>
                )}
                {rows.map(function (r) {
                    var badge = statusBadge(r);
                    var isRunning = badge.key === 'running';
                    var disabledReview = isRunning || badge.key === 'failed';
                    var docs = docsMap[r.code] || [];
                    var modeText = MODE_LABEL[r.analysis_mode]
                        ? AntLocalization.translateText(MODE_LABEL[r.analysis_mode])
                        : (r.analysis_mode || '—');
                    var validationText = r.validation_status
                        ? (VALIDATION_LABEL[r.validation_status]
                            ? AntLocalization.translateText(VALIDATION_LABEL[r.validation_status])
                            : r.validation_status)
                        : null;
                    var okN = Number(r.ok_rows || 0);
                    var errN = Number(r.error_rows || 0);
                    var skipN = Number(r.skipped_rows || 0);
                    var hasCounts = (okN + errN + skipN) > 0;

                    return (
                        <div key={r.id} className={'ant-aiwizard-card ant-aiwizard-' + badge.key}>
                            <div className="ant-aiwizard-card-head">
                                <div className="ant-aiwizard-card-head-l">
                                    <span className="ant-aiwizard-version">v{r.version}</span>
                                    <span className="ant-aiwizard-mode">{modeText}</span>
                                </div>
                                <span className={'ant-aiwizard-status ant-aiwizard-status-' + badge.key}>
                                    {isRunning && <span className="ant-aiwizard-dot" />}
                                    {badge.text}
                                </span>
                            </div>

                            <div className="ant-aiwizard-meta">
                                {fmtTime(r.created_at) && <span>{fmtTime(r.created_at)}</span>}
                                {r.created_user_name && <span className="ant-aiwizard-meta-sep">·</span>}
                                {r.created_user_name && <span>{r.created_user_name}</span>}
                            </div>

                            {docs.length > 0 && (
                                <div className="ant-aiwizard-docs">
                                    <div className="ant-aiwizard-docs-title">
                                        {AntLocalization.translateText({ vi: 'Tài liệu đính kèm', en: 'Attached documents', fr: 'Documents joints', es: 'Documentos adjuntos', id: 'Dokumen terlampir', ja: '添付書類', zh: '附件文档', ko: '첨부 문서', hi: 'संलग्न दस्तावेज़', ar: 'المستندات المرفقة' })}
                                        <span className="ant-aiwizard-docs-count">{docs.length}</span>
                                    </div>
                                    <div className="ant-aiwizard-docs-list">
                                        {docs.map(function (d) {
                                            var isImg = isImageMime(d.med_doc_mime, d.med_doc_name);
                                            return (
                                                <div key={d.code} className="ant-aiwizard-doc-item" title={d.med_doc_name || ''}>
                                                    <span className="ant-aiwizard-doc-ico">
                                                        {isImg ? <IconImage /> : <IconDoc />}
                                                    </span>
                                                    <span className="ant-aiwizard-doc-name">{d.med_doc_name || d.med_doc_code || '—'}</span>
                                                    {d.med_doc_size_bytes ? (
                                                        <span className="ant-aiwizard-doc-size">{fmtSize(d.med_doc_size_bytes)}</span>
                                                    ) : null}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}

                            {(validationText || hasCounts) && (
                                <div className="ant-aiwizard-summary">
                                    {validationText && <span className="ant-aiwizard-validation">{validationText}</span>}
                                    {validationText && hasCounts && <span className="ant-aiwizard-meta-sep">·</span>}
                                    {hasCounts && (
                                        <span className="ant-aiwizard-counts">
                                            <span className="c-ok">{okN} {lblOk}</span>
                                            <span> / </span>
                                            <span className="c-err">{errN} {lblErr}</span>
                                            <span> / </span>
                                            <span className="c-skip">{skipN} {lblSkip}</span>
                                        </span>
                                    )}
                                </div>
                            )}

                            <div className="ant-aiwizard-card-actions">
                                <button
                                    className="ant-aiwizard-review"
                                    disabled={disabledReview}
                                    onClick={function () {
                                        if (disabledReview) return;
                                        reviewRow(r);
                                    }}
                                >
                                    {r.apply_status === 'Applied'
                                        ? AntLocalization.translateText({ vi: 'Xem', en: 'View', fr: 'Voir', es: 'Ver', id: 'Lihat', ja: '表示', zh: '查看', ko: '보기', hi: 'देखें', ar: 'عرض' })
                                        : AntLocalization.translateText({ vi: 'Rà soát', en: 'Review', fr: 'Vérifier', es: 'Revisar', id: 'Tinjau', ja: '確認', zh: '审核', ko: '검토', hi: 'समीक्षा', ar: 'مراجعة' })}
                                </button>
                                <button
                                    className="ant-aiwizard-delete"
                                    disabled={isRunning}
                                    title={AntLocalization.translateText({
                                        vi: 'Xoá phân tích và file đính kèm',
                                        en: 'Delete analysis and attached files',
                                        fr: 'Supprimer l\'analyse et les fichiers joints',
                                        es: 'Eliminar análisis y archivos adjuntos',
                                        id: 'Hapus analisis dan berkas terlampir',
                                        ja: '分析と添付ファイルを削除',
                                        zh: '删除分析及附件',
                                        ko: '분석 및 첨부 파일 삭제',
                                        hi: 'विश्लेषण और संलग्न फ़ाइलें हटाएँ',
                                        ar: 'حذف التحليل والملفات المرفقة'
                                    })}
                                    onClick={function () {
                                        if (isRunning) return;
                                        deleteRow(r);
                                    }}
                                >
                                    <IconTrash />
                                </button>
                            </div>
                        </div>
                    );
                })}
                {!loading && rows.length === 0 && (
                    <div className="ant-aiwizard-empty">
                        {AntLocalization.translateText({ vi: 'Chưa có phân tích nào', en: 'No analyses yet', fr: 'Aucune analyse', es: 'Aún no hay análisis', id: 'Belum ada analisis', ja: '分析はまだありません', zh: '暂无分析', ko: '분석이 없습니다', hi: 'अभी कोई विश्लेषण नहीं', ar: 'لا تحليلات بعد' })}
                    </div>
                )}
            </div>
        </div>
    );
}
